@use "../zr-css-icon/zr-css-icon" as i;
@import "../zr-theme/zr-variables";

$component: 'zr-shipping-information';


:host {
    display: flex;
    flex-direction: row;
    gap: 16px;
    align-items: center;
    border: 1px solid var(--ci-neutral300);
    padding: 16px;
    border-radius: 4px;
}
.#{$component}__icon {
    @include i.get-icon-only(van-time);
}

#{$component}__info {
    font-size: 1em;
}
